//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'China_Stroke_Scale',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: '',
        data7: '',
        data8: '',
        data9: '',
        data10: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '0', name: '均正确' },
        { value: '1', name: '一项正确' },
        { value: '2', name: '都不正确，做以下检查重' }
      ],
      dataList2: [
        { value: '3', name: '均完成' },
        { value: '4', name: '完成一项' },
        { value: '5', name: '都不能完成，做以下检查' }
      ],
      dataList3: [
        { value: '6', name: '定向退让（躲避动作）' },
        { value: '7', name: '定向肢体回缩（对刺激的反射性动作）' },
        { value: '8', name: '肢体伸直' },
        { value: '9', name: '无反应' }
      ],
      dataList4: [
        { value: '0', name: '正常' },
        { value: '2', name: '侧视运动受限' },
        { value: '4', name: '眼球侧凝视' }
      ],
      dataList5: [
        { value: '0', name: '正常' },
        { value: '1', name: '轻瘫' },
        { value: '2', name: '可动' }
      ],
      dataList6: [
        { value: '0', name: '正常' },
        { value: '2', name: '交谈有一定困难，借助表情动作表达，或言语流利，但不易听懂，错语较多' },
        { value: '5', name: '可简单对话，但复述困难，言语多迂回，有命名障碍' },
        { value: '6', name: '词不达意' }
      ],
      dataList7: [
        { value: '0', name: 'V°正常' },
        { value: '1', name: 'IV°不能抵抗外力' },
        { value: '2', name: 'III°抬臂高于肩' },
        { value: '3', name: 'III°平肩或以下' },
        { value: '4', name: 'II°上肢与躯干夹角＞45°' },
        { value: '5', name: 'I°上肢与躯干夹角≤45°' },
        { value: '6', name: '0°不能动' }
      ],
      dataList8: [
        { value: '0', name: 'V°正常' },
        { value: '1', name: 'IV°不能紧握拳' },
        { value: '2', name: 'III°握空拳，能伸开' },
        { value: '3', name: 'III°能屈指，不能伸' },
        { value: '4', name: 'II°屈指不能及掌' },
        { value: '5', name: 'I°指微动' },
        { value: '6', name: '0°不能动' }
      ],
      dataList9: [
        { value: '0', name: 'V°正常' },
        { value: '1', name: 'IV°不能抵抗外力' },
        { value: '2', name: 'III°抬腿45°以上，踝或趾可动' },
        { value: '3', name: 'III°抬腿45°左右，踝或趾不能动' },
        { value: '4', name: 'II°抬腿离床不足45°' },
        { value: '5', name: 'I°水平移动，不能抬高' },
        { value: '6', name: '0°不能动' }
      ],
      dataList10: [
        { value: '0', name: '正常行走' },
        { value: '1', name: '独立行走5米以上，跛行' },
        { value: '2', name: '独立行走，需扶杖' },
        { value: '3', name: '有人扶持下可以行走' },
        { value: '4', name: '自己站立，不能走' },
        { value: '5', name: '坐不需支持，但不能站立' },
        { value: '6', name: '卧床' }
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      console.log(form, 7777)
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            if (key === 'data2' && form['data1'] === '2') {
              flag = false
            } else if (key === 'data3' && form['data2'] === '5') {
              flag = false
            } else if (key !== 'data2' && key !== 'data3') {
              flag = false
            }
          } else {
            console.log(key, form[key], 8888)
            form[key] = Number(form[key])
          }
        }
      }
      console.log(form, flag, 9999)
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // weight + airways + systolicBP + cns + cutaneousWound + fracture
        let result = 0
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            if (key !== 'data1' && key !== 'data2' && key !== 'data3') {
              result = form[key] + result
            }
          }
        }
        if (form.data1 === 2) {
          if (form.data2 === 5) {
            result = result + form.data3
          } else {
            result = result + form.data2
          }
        } else {
          result = result + form.data1
        }
        console.log(result, 6666)
        self.hasScore = true
        if (result <= 15) {
          return '轻型'
        } else if (result <= 30 && result >= 16) {
          return '中型'
        } else if (result >= 31) {
          return '重型'
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/China_Stroke_Scale.vue